import { TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { t } from 'i18next';

export const TextFieldCity = ({ values, handleChange, errors, touched }) => (
    <TextField
        fullWidth
        label={t('users.fields.city')}
        name="city"
        value={values.city}
        error={touched.city && Boolean(errors.city)}
        helperText={touched.city && errors.city}
        onChange={handleChange}
    />
);

TextFieldCity.propTypes = {
    values: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    touched: PropTypes.object.isRequired
};
